import script from "./ProfessionSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfessionSearch.vue?vue&type=script&lang=ts&setup=true"

import "./ProfessionSearch.vue?vue&type=style&index=0&id=e8935bd8&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8935bd8"]])

export default __exports__